// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Roque",
  middleName: "Rojo",
  lastName: "Bacete",
  message: " Cambiando el mundo con tecnología ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/RoqueRojo",
    },
    {
      image: "fa-facebook",
      url: "https://www.facebook.com/roque.rojobacete",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/roquerojo96/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/roque-rojo-bacete-490b471bb/",
    },
    {
      image: "fa-twitter",
      url: "https://www.twitter.com/roquerojo96/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/16apx8s6zlVwCu7Aea6jdJtXOnAb6GsNP8QAsTv7gWZo/edit",

const about = {
  show: true,
  heading: "Acerca de mi",
  imageLink: require("../editable-stuff/RoqueRojo.png"),
  imageSize: 375,
  message:
    "Mi nombre es Roque Rojo Bacete, tengo 24 años y actualmente soy estudiante de ultimo año de Ingeniería Informática. Amante de los deportes (como son las artes marciales y la natación),los animales, las buenas series y de lo poco convencional.",
  resume: require("../editable-stuff/resume.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Proyectos Recientes",
  gitHubUsername: "RoqueRojo", //i.e."johnDoe12Gh"
  reposLength: 4,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: true,
  heading: "Premios",
  message:
    "Durante el año 2018 juntos a unos amigos fui galardonado con el primer premio en el prestigioso concurso Hack4Good con la applicación Cuida de Beni, la cual consistía en la creación de una aplicación en que los usuarios de la applicación cuidaban de un avatar virtual cuidando sus propios hábitos, los datos de la applicación eran obtenidos del usuario mediante una pulsera biometrica como puede ser una Xiaomi Mi Band, creando así el concepto de tamagotchi inverso, por lo que el la salud del avatar virtual sería un reflejo de nuestra propoia salud, por lo que ayudamos a fomentar una vida más saludable (basandose en las horas de sueño, pasos, actividad física, ritmo cardiaco)",
  images: [
    { 
      img: require("../editable-stuff/h4g1.png"), 
    },
    { 
      img: require("../editable-stuff/h4g2.png"), 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Habilidades",
  hardSkills: [
    { name: "Python", value: 80 },
    { name: "SQL", value: 75 },
    { name: "Java", value: 95 },
    { name: "C/C++/C#", value: 75 },
    { name: "JavaScript", value: 90 },
    { name: "React", value: 65 },
    { name: "HTML/CSS", value: 55 },
    { name: "Visual Basic,C# .NET", value: 90 },
  ],
  softSkills: [
    { name: "Integridad", value: 80 },
    { name: "Trabajo en Equipo", value: 90 },
    { name: "Postividad", value: 75 },
    { name: "Adaptabilidad", value: 95 },
    { name: "Resolución de Problemas", value: 90 },
    { name: "Empatia", value: 90 },
    { name: "Organización", value: 70 },
    { name: "Creatividad", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Contacta conmigo",
  message:
    "Ahora mismo soy estudiante a tiempo completo en la Escuela superior de Informatica en Ciudad Real, pero estaré encantado de responder a dudas o propuestas de trabajo, no dudeis de mandarme un e-mail",
  email: "Rojobaceteroque@gmail.com",
};

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch };
